import { createStore, combineReducers } from 'redux'
import display from './simulationAdaptation/display'
import angleSectionLine from './simulationAdaptation/angleSectionLine'
import updateLens from './simulationAdaptation/updateLens'
import cornealTopographic from 'src/actions/simulationAdaptation/cornealSlice'

export const rootReducer = combineReducers({
  display,
  angleSectionLine,
  updateLens,
  cornealTopographic: cornealTopographic.reducer,
})

const store = createStore(rootReducer)

export type storeTypes = ReturnType<typeof store.getState>

export default store
